'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { OLAF, BATTLESHIP } from 'HubStyleTokens/colors';
import { getLocalStorageItem } from 'collaboration-sidebar/utils/localStorage';
import { COLLAPSED_SIDEBAR_WIDTH } from 'collaboration-sidebar/constants/sidebar';
import { COLLABORATION_SIDEBAR_HIDDEN } from 'collaboration-sidebar/constants/localStorageKeys';
import useNavBottomPosition from 'collaboration-sidebar/hooks/useNavBottomPosition';
const StyledSidebarSpacer = styled.aside.withConfig({
  displayName: "SidebarSkeleton__StyledSidebarSpacer",
  componentId: "sc-1ldts7y-0"
})(["flex:0 0 auto;width:", "px;min-width:", "px;max-width:calc(26vw + ", "px);"], COLLAPSED_SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH);
const StyledSidebar = styled(UIFlex).withConfig({
  displayName: "SidebarSkeleton__StyledSidebar",
  componentId: "sc-1ldts7y-1"
})(["border-left:1px solid ", ";background-color:", ";height:calc(100vh - ", "px);position:fixed;width:", "px;min-width:", "px;max-width:calc(26vw + ", "px);right:0;"], BATTLESHIP, OLAF, ({
  navBottomPosition
}) => navBottomPosition, COLLAPSED_SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH);

function SidebarSkeleton() {
  const navBottomPosition = useNavBottomPosition(); // Defaults to not showing the sidebar skeleton if there is no local storage
  // value set or if it is set to hidden with 'true'.

  if (getLocalStorageItem(COLLABORATION_SIDEBAR_HIDDEN) !== 'false') {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledSidebarSpacer, {
    navBottomPosition: navBottomPosition,
    children: /*#__PURE__*/_jsx(StyledSidebar, {
      navBottomPosition: navBottomPosition
    })
  });
}

export default SidebarSkeleton;